import { fontFamily } from "@mui/system";

export const defaultTypography: any = {
  body1: { fontWeight: '400' },
  body2: { fontWeight: '400' },
  h1: { fontWeight: '700' },
  h2: { fontWeight: '700' },
  h3: { fontWeight: '600' },
  h4: { fontWeight: '600' },
  h5: { fontWeight: '500' },
  h6: { fontWeight: '500' },
  subtitle1: { fontWeight: '600' },
  button: {
    textTransform: "none" as const,
  },
};
